import { useCallback } from "react"
import { Geocode, LocationCoordsCache } from "../types"
import { geocodeFromPartialAddress } from "../utils/locationUtils"
import { useAsync } from "./useAsync"

export function toGeocode(geocodeFull: LocationCoordsCache): Geocode {
  return {
    lat: geocodeFull.latitude,
    lng: geocodeFull.longitude,
    city: geocodeFull.city,
    state: geocodeFull.administrativeLevels.level1short,
    zipcode: geocodeFull.zipcode,
  }
}

export function useGeocodeFromPartialAddress(
  address: string | null | undefined,
) {
  return useAsync({
    disabled: !address,
    operation: useCallback(async () => {
      const newCoordinates = await geocodeFromPartialAddress(address!)
      return toGeocode(newCoordinates)
    }, [address]),
  })
}
